/**
 * Stable identity used for persisted project visibility. Display labels are not
 * unique and can change while workspace metadata is being reconciled, whereas
 * the repository path remains stable across app reloads.
 */
export function projectStorageKey(
  project: string,
  projectPaths: ReadonlyMap<string, string>,
): string {
  return projectPaths.get(project) ?? project;
}

export function isProjectRemoved(
  project: string,
  projectPaths: ReadonlyMap<string, string>,
  removedProjects: ReadonlySet<string>,
): boolean {
  return removedProjects.has(projectStorageKey(project, projectPaths));
}
